import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface WindowNHQ {
  data: any;
  content :any;
  removing : 'none' | 'pending' | 'success';
  adding : 'none' | 'pending' | 'success';
}

const initialState: WindowNHQ = {
  data: [],
  content : [],
  removing : 'none',
  adding : 'none'
};

const windowNHQSlice = createSlice({
  name: 'windowNHQ',
  initialState,
  reducers: {
    setWindowNHQ: (state, action: PayloadAction<any>) => {
      state.adding = 'pending'
        let updatedData = [...state.data, action.payload]
        state.data = updatedData;
        // let updatedContent = [...state.content, action.payload]
        // if (state.content.some((e:any) => e.id !== action.payload?.id)){
          state.content = updatedData;
          // console.log("WINDOW IT ADDED IN THE CONTENT")
        // }
        console.log(state.data, 'updated data LAST')
      state.adding = 'success'
      
    },

    removeLastWindowNHQ: (state:any) => {
      state.removing = 'pending';
      let newData  = state.data?.slice(0, -1)
      state.data = newData
      console.log(newData, 'NEW DATAAA LAST')
      state.removing = 'success';
      
    },

    changeRemoving: (state:any, action : PayloadAction<any>) => {
      state.removing = action.payload
    },
    changeAdding: (state:any, action : PayloadAction<any>) => {
      state.adding = action.payload
    }
  },
});

export const { setWindowNHQ, removeLastWindowNHQ, changeRemoving , changeAdding} = windowNHQSlice.actions;
export default windowNHQSlice.reducer;
